import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";

const Tietosuoja = () => {
  return (
    <>
      <SEOHead
        title="Tietosuojaseloste | Keski-Uudenmaan Kaihdin"
        description="Keski-Uudenmaan Kaihtimen tietosuojaseloste. Lue miten käsittelemme henkilötietojasi GDPR:n mukaisesti."
        path="/tietosuoja"
        alternatePath="/en/privacy-policy"
      />
      <Header />
      <main id="main-content" className="min-h-screen">
        <div className="container max-w-3xl py-16 md:py-24">
          <h1 className="font-display text-3xl md:text-4xl font-bold mb-8">Tietosuojaseloste</h1>
          <p className="text-muted-foreground text-sm mb-8">Päivitetty: 4.3.2026</p>

          <div className="prose prose-sm max-w-none space-y-6 text-foreground/90">
            <section>
              <h2 className="font-display text-xl font-semibold mt-8 mb-3">1. Rekisterinpitäjä</h2>
              <p>
                Tmi Teppo Honkanen<br />
                Y-tunnus: 2303843-1<br />
                Iltalenkki 23, 05400 Jokela<br />
                Puhelin: 040 583 9991<br />
                Sähköposti: info@ku-kaihdin.fi
              </p>
            </section>

            <section>
              <h2 className="font-display text-xl font-semibold mt-8 mb-3">2. Kerättävät henkilötiedot</h2>
              <p>Keräämme verkkosivustomme yhteydenottolomakkeen kautta seuraavia tietoja:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>Nimi</li>
                <li>Sähköpostiosoite</li>
                <li>Puhelinnumero (vapaaehtoinen)</li>
                <li>Vapaamuotoinen viesti</li>
              </ul>
            </section>

            <section>
              <h2 className="font-display text-xl font-semibold mt-8 mb-3">3. Henkilötietojen käsittelyn tarkoitus ja peruste</h2>
              <p>Henkilötietoja käsitellään seuraaviin tarkoituksiin:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li><strong>Yhteydenottopyyntöihin vastaaminen</strong> – Käsittelyn oikeusperuste: sopimusta edeltävien toimenpiteiden toteuttaminen (GDPR 6 art. 1 kohta b).</li>
                <li><strong>Markkinointi</strong> – Käsittelyn oikeusperuste: rekisterinpitäjän oikeutettu etu (GDPR 6 art. 1 kohta f). Sinulla on oikeus vastustaa markkinointia milloin tahansa.</li>
              </ul>
            </section>

            <section>
              <h2 className="font-display text-xl font-semibold mt-8 mb-3">4. Tietojen säilytysaika</h2>
              <p>
                Yhteydenottolomakkeen kautta saatuja tietoja säilytetään niin kauan kuin on tarpeen yhteydenoton käsittelemiseksi ja mahdollisen asiakassuhteen hoitamiseksi. Markkinointitarkoituksiin säilytettävät tiedot poistetaan viimeistään, kun vastustat tietojesi käyttöä markkinointiin.
              </p>
            </section>

            <section>
              <h2 className="font-display text-xl font-semibold mt-8 mb-3">5. Tietojen luovutukset ja siirrot</h2>
              <p>
                Henkilötietoja ei luovuteta kolmansille osapuolille eikä siirretä EU/ETA-alueen ulkopuolelle.
              </p>
            </section>

            <section>
              <h2 className="font-display text-xl font-semibold mt-8 mb-3">6. Rekisteröidyn oikeudet</h2>
              <p>Sinulla on GDPR:n mukaisesti oikeus:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li>Saada pääsy omiin henkilötietoihisi</li>
                <li>Pyytää tietojesi oikaisemista tai poistamista</li>
                <li>Rajoittaa tai vastustaa tietojesi käsittelyä</li>
                <li>Siirtää tietosi toiselle rekisterinpitäjälle</li>
                <li>Tehdä valitus valvontaviranomaiselle (Tietosuojavaltuutetun toimisto, <a href="https://tietosuoja.fi" target="_blank" rel="noopener noreferrer" className="text-primary underline">tietosuoja.fi</a>)</li>
              </ul>
              <p className="mt-3">Voit käyttää oikeuksiasi ottamalla yhteyttä: <a href="mailto:temmonteppo@gmail.com" className="text-primary underline">temmonteppo@gmail.com</a></p>
            </section>

            <section>
              <h2 className="font-display text-xl font-semibold mt-8 mb-3">7. Tietoturva</h2>
              <p>
                Henkilötietojen käsittelyssä noudatetaan huolellisuutta ja tietojärjestelmien avulla käsiteltävät tiedot suojataan asianmukaisesti. Pääsy tietoihin on rajattu vain niille henkilöille, joille se on tarpeellista.
              </p>
            </section>

            <section>
              <h2 className="font-display text-xl font-semibold mt-8 mb-3">8. Evästeet</h2>
              <p>
                Tämä verkkosivusto ei käytä evästeitä eikä kolmannen osapuolen seurantateknologioita.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Tietosuoja;
